import { render, staticRenderFns } from "./newform.vue?vue&type=template&id=1d011db9&scoped=true"
import script from "./newform.vue?vue&type=script&lang=js"
export * from "./newform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d011db9",
  null
  
)

export default component.exports